import { convertToInterestFraction } from "../commons";
import { PaymentInterval } from "../simulator/simulator";

export interface IPmtInfo {
    pmt: number;
    downPaymentsPmt?: number;
}

export interface IPmtCalculateParams {
    amount: number;
    tenure: number;
    interestRate: number;
    paymentInterval: PaymentInterval;
    downPayments?: number;
}

export const calculatePmt = (request: IPmtCalculateParams): IPmtInfo => {
    const { amount, tenure, interestRate, paymentInterval, downPayments } = request;

    if (interestRate == 0) {
        return {
            pmt: amount / tenure,
            downPaymentsPmt: downPayments ? 0 : null
        };
    }

    const interestFraction = convertToInterestFraction(interestRate, paymentInterval);
    const interestFactor = Math.pow((1 + interestFraction), tenure)

    const pmt = (amount * (interestFraction * interestFactor)) / (interestFactor - 1);
    const downPaymentsPmt = downPayments ? interestFraction * amount : null;

    const pmtInfo: IPmtInfo = {
        pmt,
        downPaymentsPmt
    };

    return pmtInfo;
}
